module.exports = __webpack_public_path__ + "img/invite-friendsTop.1fbb3eda.png";